import { Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { createRoot, Root } from 'react-dom/client';
import { loadRemote } from '@module-federation/enhanced/runtime';
import { createElement, FC, lazy, PropsWithChildren, Suspense } from 'react';
import { ErrorBoundary, QueryClientProvider } from '@frontend/profilum-components';
import { queryClient, idbPersister, AppConfigProvider, appConfig } from '@pflm-shared';

const ReactLazyComponent: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ErrorBoundary>
      <AppConfigProvider config={appConfig}>
        <QueryClientProvider queryClient={queryClient} persister={idbPersister}>
          <Suspense>{children}</Suspense>
        </QueryClientProvider>
      </AppConfigProvider>
    </ErrorBoundary>
  );
};

@Directive({
  standalone: true,
  selector: '[ngReact]',
})
export class NgReactDirective implements OnDestroy {
  @Input() set ngReact(path: string) {
    const RemoteApp = lazy(() => loadRemote(path));

    this.root.render(createElement(ReactLazyComponent, { children: <RemoteApp /> }));
  }

  private root: Root;

  constructor(private element: ElementRef) {
    this.root = createRoot(element.nativeElement);
  }

  public ngOnDestroy(): void {
    this.root.unmount();
  }
}
